import { render, staticRenderFns } from "./dutyFree.vue?vue&type=template&id=dfc81eb8&scoped=true&"
import script from "./dutyFree.vue?vue&type=script&lang=js&"
export * from "./dutyFree.vue?vue&type=script&lang=js&"
import style0 from "./dutyFree.vue?vue&type=style&index=0&id=dfc81eb8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc81eb8",
  null
  
)

export default component.exports